import { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { faEdit, faTrash } from "@fortawesome/free-solid-svg-icons";
import InfoIcon from "../../../InfoIcon";



import { Link, useNavigate } from "react-router-dom";
import useVariable from './../../../../hook/useVariable';
import Backdrop from './../../../Backdrop';

import ResortIcons from "./desktopcomponent/ResortIcons";

import Filter from "./desktopcomponent/Filter";
import useRole from "../../../../hook/useRole";
import useFetch from "../../../../hook/useFetch";
import { notificationActions } from "../../../../store/notification-slice";

export default function DesktopComponent(props) {


    let filteredUsers = useSelector((state) => state.user.filteredUsers)

    const [desktopItems, setDesktopItems] = useState([])

    let stateusers = useSelector(state => state.user.users)


    useEffect(() => {

        let items = []
        let users = filteredUsers ?? stateusers
        if (users && Object.keys(users).length > 0) {
            users.forEach((user) => {

                items.push(<DesktopItem key={user.id} user={user} />)

            })
        }
        setDesktopItems(items)

    }, [filteredUsers])


    return <Fragment>
        <Filter>

            <div className="table-responsive dashboard-data-table-scroll">
            <table className="table table-striped table-bordered dashboard-data-table" >
                <thead>
                    <tr>

                        <th>ID <ResortIcons type='id' /></th>
                        <th>Username <ResortIcons type='username' /></th>
                        <th>Email <ResortIcons type='email' /></th>
                        <th>IsAdmin <ResortIcons type='is_admin' /></th>
                        <th>Status <ResortIcons type='status' /></th>
                        <th>Activated <ResortIcons type='activated' /></th>
                        <th>CreatedOn <ResortIcons type='created_on' /></th>
                        <th className="table-actions">Actions</th>

                    </tr>
                </thead>
                <tbody>
                    {desktopItems}
                </tbody>
            </table>
            </div>
        </Filter>
        <Backdrop />
    </Fragment>
}




const DesktopItem = (props) => {
    const { user } = props
    const { variableValue } = useVariable()


    let id = variableValue(user.id)
    let username = variableValue(user.username)
    let isAdmin = variableValue(user.is_admin)

    let email = variableValue(user.email)
    let status = variableValue(user.status)
    status = status ? 'online' : 'offline'
    let createdOn = variableValue(user.created_on)

    const { hasrole } = useRole('rsosuperuser')

    const { del } = useFetch()


    let dispatch = useDispatch()

    let navigate = useNavigate()

    return <Fragment>

        <tr>

            <td>
                {id}
            </td>
            <td>
                {username}
            </td>
            <td>
                {email}
            </td>
            <td>
                {isAdmin ? 'true' : 'false'}
            </td>

            <td>
                {status}
            </td>
            <td>
                {user.activated ? 'true' : 'false'}
            </td>

            <td>
                {createdOn}
            </td>
            <td className="table-actions">
                <div className="table-action-buttons">
                <Link className="btn btn-outline-secondary bgnt" to={`/admin/users/${id}`} ><InfoIcon icon={faEdit} title='edit user' /></Link>
                <button className="btn btn-warning" disabled={!hasrole} onClick={() => {
                    del(`/admin/user`, {
                            'id': id
                        }, (data) => {
                            dispatch(notificationActions.setNotification({
                                message: data,
                                status: false
                            }))
                        },
                            () => {
                                dispatch(notificationActions.setNotification({
                                    message: `user deleted`,
                                    status: true
                                }))


                                navigate('/admin/users', {
                                    state: {
                                        refetch: true
                                    }
                                })
                            })
                }}  ><InfoIcon icon={faTrash} title='delete user' /></button>
                </div>
            </td>


        </tr>

    </Fragment>
}
